import { initReactI18next } from "react-i18next";
import { Language } from "../../type/Translations.js";
import * as contentful from "contentful";
import i18n from "i18next";
import { default as default2 } from "i18next";
import _set from "lodash/set.js";
import { Remarkable } from "remarkable";
import RemarkableReactRenderer from "remarkable-react";
const md = new Remarkable({
  linkTarget: "_blank"
});
md.renderer = new RemarkableReactRenderer();
const markdownRenderer = (str) => {
  return md.renderInline(str);
};
const markdownModule = {
  type: "postProcessor",
  name: "markdown",
  process(value) {
    return markdownRenderer(value);
  }
};
const markdownBlockModule = {
  type: "postProcessor",
  name: "markdownBlock",
  process(value) {
    return md.render(value);
  }
};
const supportedLanguages = ["en", "de", "cimode"];
const isLanguageValid = (language) => supportedLanguages.includes(language.toLowerCase());
const getLanguageFromNavigator = () => {
  try {
    return window.navigator.language.substring(0, 2) || void 0;
  } catch (e) {
  }
};
const getCurrentLanguage = () => {
  const language = getLanguageFromNavigator();
  if (language && isLanguageValid(language))
    return language.toLowerCase();
  return Language.DEUTSCH;
};
const init = (language) => (resources) => {
  const instance = i18n.use(markdownModule).use(markdownBlockModule).use(initReactI18next).init({
    resources: {
      en: { translation: resources.en },
      de: { translation: resources.de }
    },
    lng: language,
    fallbackLng: Language.ENGLISH,
    interpolation: {
      escapeValue: false
    },
    postProcess: [markdownModule.name]
  });
  return instance;
};
const shouldUsePreview = ["development", "preview"].includes(process.env.REACT_APP_ENV || "");
const client = ({ space, accessToken }) => contentful.createClient({
  space,
  accessToken,
  host: shouldUsePreview ? "preview.contentful.com" : void 0
});
const toTranslationObject = (result) => {
  return result.items.reduce((acc, item) => {
    return _set({ ...acc }, item.fields.key, item.fields.translation);
  }, {});
};
const getTranslations = async ({
  applicationSlug,
  clientConfig
}) => {
  const defaultQuery = {
    content_type: "translation",
    "sys.contentType.sys.id": "translation",
    "fields.application.fields.slug": applicationSlug,
    "fields.application.sys.contentType.sys.id": "application",
    limit: 1e3
  };
  const [de, en] = await Promise.all([
    client(clientConfig).getEntries({ ...defaultQuery, locale: "de-DE" }).then(toTranslationObject),
    client(clientConfig).getEntries({ ...defaultQuery, locale: "en-US" }).then(toTranslationObject)
  ]);
  return { de, en };
};
export {
  default2 as default,
  getCurrentLanguage,
  getTranslations,
  init
};
